import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelectItem, LazyLoadEvent } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { CustomReportExportComponent } from 'src/app/components/extract-custom-report/custom-report-export.component';
import { AccessGroup } from 'src/app/models/dtos/access-controller/access-group';
import { FinancialStatusDto } from 'src/app/models/dtos/report/financial-status-dto';
import { FinancialStatusReport } from 'src/app/models/dtos/report/financial-status-report';
import { Currency } from 'src/app/models/enums/currency';
import { PaginationFilter } from 'src/app/models/pagination-filter';
import { AccessGroupService } from 'src/app/services/access-controler/access-group.service';
import { CurrencyService } from 'src/app/services/currency.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-financialStatusReport',
  templateUrl: './financialStatusReport.component.html',
  styleUrls: ['./financialStatusReport.component.scss']
})
export class FinancialStatusReportComponent implements OnInit {

  filter:FinancialStatusReport;

  report:FinancialStatusDto[]= [];
  currentCurrency: Currency = Currency.BRL;
  hasSearched = false;
  noResults = false;
  paginationFilter: PaginationFilter = new PaginationFilter();
  totalRecords: number = 0;
  totalValue: number = 0;
  totalGeral: number = 0;
  allowAutoLoad: boolean = false;

  accessgroupOption: SelectItem[] = [];
  constructor(
    private accessGroupService: AccessGroupService,
    private spinner: NgxSpinnerService,
    private toasty: ToastService,
    private invoiceService: InvoiceService,
    public dialog: DialogService,
    private currencyService: CurrencyService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.currentCurrency = this.currencyService.getCurrentCurrency();

    this.filter = new FinancialStatusReport();
    this.filter.starDate = new Date();
    this.filter.starDate.setMonth(this.filter.starDate.getMonth() - 1);
    this.filter.endDate = new Date();
    this.findAllAccessCategories();
  }

  findAllAccessCategories() {
    this.spinner.show();
    this.accessGroupService.findAll().subscribe({
      next: (categories) => {
        this.accessgroupOption = categories.map((category) => {
          return { label: category.name, value: category.id };
        }
        );


        this.spinner.hide();
      },
      error: (error) => {
        this.spinner.hide();
        this.toasty.error(error.message ?? 'Erro ao iniciar a tela');
      },

    });
  }

  search() {
    this.spinner.show();
    this.paginationFilter.page = 0;
    this.allowAutoLoad = true;
    this.loadReport();
  }

  loadReport() {
    console.log('Método loadReport chamado');
    this.invoiceService.financialStatusReport(this.filter, this.paginationFilter).subscribe({
      next: (response) => {
        const reportPage = response.report;
        this.report = reportPage.content || [];
        this.totalRecords = reportPage.totalElements || 0;
        
        this.totalGeral = response.totalGeral || 0;
        this.hasSearched = true;
        this.cdr.detectChanges();
        this.noResults = !this.report || this.report.length === 0;
      },
      error: (error) => {
        this.toasty.error(error.message ?? 'Erro ao buscar relatório');
        this.hasSearched = true;
        this.noResults = true;
      },
    }).add(() => {
      this.spinner.hide();
    });
  }

  onChangePage(event: LazyLoadEvent): void {
    if (!this.allowAutoLoad) {
      return;
    }
    
    const page = event.first / event.rows;
    if (event.sortField) {
      this.paginationFilter.sort = event.sortField;
      this.paginationFilter.order = event.sortOrder === 1 ? 'ASC' : 'DESC';
    }
    this.paginationFilter.page = page;
    this.paginationFilter.size = event.rows;
    this.loadReport();
  }

  clear() {
    this.report = [];
    this.hasSearched = false;
    this.noResults = false;
    this.totalRecords = 0;
    this.paginationFilter = new PaginationFilter();
  }

  exportTablePdf(){
    this.spinner.show();
    
    const exportPaginationFilter = {
      ...this.paginationFilter,
      size: 10000,
      page: 0
    };

    this.invoiceService.financialStatusReport(this.filter, exportPaginationFilter).subscribe({
      next: (response) => {
        const reportPage = response.report;
        const allData = reportPage.content || [];
        
        const dataExport = {
          table: allData, 
          type: 'FINANCIAL_STATUS_REPORT',
          totalGeral: response.totalGeral || 0
        };
        this.dialog.open(CustomReportExportComponent, {
          width: '70%',
          height: '90vh',
          dismissableMask: false,
          data: dataExport,
          header: 'Exportar Relatório de Financeiro',
        });
        
        this.spinner.hide();
      },
      error: (error) => {
        console.error('Erro ao exportar dados:', error);
        this.spinner.hide();
      }
    });
  }
}
